module.exports = __webpack_public_path__ + "static/media/img20.8414db24.jpg";